import { residentialEnum, commercialEnum } from '../../../containers/orders-filter-bar-container/static-criteria-arguments';

// As we are transitioning filters in to the new contract, some filters enumerated values have changed this map helps cover old filters tied to a saved view.
const appliedFilterValueMap = {
  isResidential: (value) => (value ? residentialEnum : commercialEnum),
};

export const setInitialArgument = (appliedFilter, argumentOptions, defaultArgument) => {
  if (!appliedFilter) {
    return defaultArgument || argumentOptions[0];
  }

  const { criterionArgumentValue, filterValue } = appliedFilter;
  const appliedFilterMapper = appliedFilterValueMap[filterValue];
  const option = argumentOptions.find(({ value }) => {
    if (appliedFilterMapper) {
      return value === appliedFilterMapper(criterionArgumentValue);
    }
    return value === criterionArgumentValue;
  });
  return option || { value: criterionArgumentValue };
};

export const setInitialOperator = (appliedFilter, operatorOptions) => {
  if (!appliedFilter) {
    return operatorOptions[0];
  }
  const { criterionOperatorValue } = appliedFilter;
  return operatorOptions.find((option) => option.value === criterionOperatorValue) || operatorOptions[0];
};

export const setInitialMeta = (appliedFilter, metaOptions, defaultMeta) => {
  if (!appliedFilter) {
    return defaultMeta || metaOptions[0];
  }
  const { criterionMeta } = appliedFilter;
  return metaOptions.find((option) => option.value === criterionMeta) || criterionMeta;
};
